import { Link } from 'react-router-dom';
import DashboardCard from '../dashboard/DashboardCard';
import LauncherCardGroup from '../../navigation/LauncherCards';
import { useGlobalStore } from '../../stores/globalStore';
import { useGettingStarted } from '../../api/gettingStartedApi';
import { progress, resumeStep, showSetupChecklist } from './wizardModel';
import { stepInfo } from './steps';
import { useGettingStartedAccess } from './useGettingStartedAccess';
import './gettingStarted.css';

/**
 * The dashboard's Setup checklist: how far setup has got and the next step, with a link back in.
 * Only while Getting Started is on for the facility and not signed off, and only for the people who
 * may use it; otherwise nothing renders and nothing is asked of the API.
 */
export default function SetupChecklistCard() {
  const facilityId = useGlobalStore((s) => s.facilityId);
  const allowed = useGettingStartedAccess();
  const { data } = useGettingStarted(facilityId, allowed);
  if (!allowed || !showSetupChecklist(data)) return null;
  const steps = data!.steps!;
  const { done, total } = progress(steps);
  const next = resumeStep(steps);
  const label = stepInfo(next)?.label ?? next;
  return (
    <DashboardCard icon="bi-list-check" title="Setup checklist" severity="info">
      <div className="gs-card">
        <p>{`${done} of ${total} setup steps finished.`}</p>
        <progress max={total} value={done} aria-label="Setup progress">{`${done} of ${total}`}</progress>
        <p>
          Next: <Link to={`/getting-started/${next}`}>{label}</Link>
        </p>
        <p>
          <Link to="/allergy-protection">Check allergy protection</Link>
        </p>
      </div>
    </DashboardCard>
  );
}

/** Setup's own page: a Getting Started card above the other groups while the wizard is on here. */
export function GettingStartedLauncher() {
  const facilityId = useGlobalStore((s) => s.facilityId);
  const allowed = useGettingStartedAccess();
  const { data } = useGettingStarted(facilityId, allowed);
  if (!allowed || !data?.enabled || !data.steps?.length) return null;
  return (
    <LauncherCardGroup
      idPrefix="section-home-setup"
      title="Getting Started"
      cards={[{
        key: '/getting-started',
        label: 'Getting Started',
        route: '/getting-started',
        icon: 'bi-flag',
        description: data.finished
          ? 'Setup is signed off. Look back over the steps.'
          : 'Work through the steps to your first service, and pick up where you left off.',
      }]}
    />
  );
}
